/* JAYKEI About: scroll-in entrances, a parallax drift on the hero heading, the
   dashed curve drawing itself, and the pointer trail on the scatter section. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- entrances ---- */
  function intro(root) {
    if (root.dataset.intro === 'ready' || reduced) return;
    if (!('IntersectionObserver' in window)) return;   // CSS leaves it visible
    root.dataset.intro = 'ready';

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);

    // The hero is ~1400px tall and starts at the top of the page, so watching
    // the section fires the moment it loads - the cards and the curve were
    // playing out while still far below the fold. They get their own observer
    // so each one waits until it is actually on screen.
    var parts = root.querySelectorAll('[data-jk-reveal]');
    if (!parts.length) return;
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-shown');
        io2.unobserve(e.target);
      });
    }, {
      // Fire when the element's top crosses 65% of the viewport, not when a
      // sliver of it appears: the cards poke into a tall viewport while still
      // at the very bottom, and the reveal was finishing before they arrived.
      threshold: 0,
      rootMargin: '0px 0px -35% 0px'
    });
    [].forEach.call(parts, function (el) { io2.observe(el); });
  }

  /* ---- parallax ---- */
  function parallax(root) {
    var layers = [].slice.call(root.querySelectorAll('[data-jk-par]'));
    if (!layers.length || reduced) return;
    var ticking = false;
    function apply() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < -300 || rect.top > window.innerHeight + 300) return;
      var scrolled = Math.max(0, -rect.top);
      layers.forEach(function (el) {
        var rate = parseFloat(el.dataset.jkPar) || 0;
        el.style.setProperty('--jk-py', (scrolled * rate).toFixed(2) + 'px');
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  /* ---- pointer trail ----
     Tiles spawn under the cursor, pop in, then drift to the centre of the stage
     and fade out. Source images come from the tiles already on the page, so the
     trail always uses the section's own artwork. */
  function trail(root) {
    if (reduced) return;
    var stage = root.querySelector('[data-jk-trail-stage]');
    var sources = [].slice.call(root.querySelectorAll('.jk-abx__tile img'));
    if (!stage || !sources.length) return;
    // init() runs again on every shopify:section:load, and without this the
    // listener stacked up - three loads meant three tiles per tap.
    if (root.dataset.trail === 'on') return;
    root.dataset.trail = 'on';

    /* A touch screen has no hover to trail from, so there the same tile is
       spawned on each tap instead. Everything after the spawn point is shared:
       only what triggers it differs. */
    var fine = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches) &&
               !(window.matchMedia && window.matchMedia('(max-width: 989px)').matches);

    var MIN_GAP = 90;      // px of travel between spawns, so it does not flood
    var LIFE = 1100;       // ms from spawn to gone
    var last = null, n = 0, live = 0;

    function spawn(clientX, clientY) {
      if (live > 14) return;
      var box = stage.getBoundingClientRect();
      var x = clientX - box.left, y = clientY - box.top;

      var src = sources[n++ % sources.length];
      var tile = document.createElement('span');
      tile.className = 'jk-abx__trailtile';
      var img = document.createElement('img');
      img.src = src.currentSrc || src.src;
      img.alt = '';
      tile.appendChild(img);
      tile.style.left = x + 'px';
      tile.style.top = y + 'px';
      tile.style.opacity = '0';
      tile.style.transform = 'scale(0.4) rotate(' + ((n % 5) - 2) * 4 + 'deg)';
      stage.appendChild(tile);
      live++;

      // pop in with a little overshoot
      requestAnimationFrame(function () {
        tile.style.transition = 'transform 420ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 220ms ease';
        tile.style.opacity = '1';
        tile.style.transform = 'scale(1) rotate(' + ((n % 5) - 2) * 4 + 'deg)';
      });

      // then get drawn toward the middle and vanish
      window.setTimeout(function () {
        var cx = box.width / 2 - x, cy = box.height / 2 - y;
        tile.style.transition = 'transform ' + LIFE + 'ms cubic-bezier(0.55, 0, 0.35, 1), opacity ' + LIFE + 'ms ease';
        tile.style.opacity = '0';
        tile.style.transform = 'translate(' + (cx * 0.85) + 'px,' + (cy * 0.85) + 'px) scale(0.25)';
      }, 260);

      window.setTimeout(function () {
        tile.parentNode && tile.parentNode.removeChild(tile);
        live--;
      }, 260 + LIFE + 60);
    }

    if (fine) {
      root.addEventListener('pointermove', function (e) {
        var box = stage.getBoundingClientRect();
        var x = e.clientX - box.left, y = e.clientY - box.top;
        // a spacing gate, so a slow drag does not flood the stage
        if (last && Math.hypot(x - last.x, y - last.y) < MIN_GAP) return;
        last = { x: x, y: y };
        spawn(e.clientX, e.clientY);
      }, { passive: true });
    } else {
      // The tiles are the section's own artwork and the stage sits behind the
      // heading, so a tap anywhere in the section drops one where it landed.
      root.addEventListener('pointerdown', function (e) {
        spawn(e.clientX, e.clientY);
      }, { passive: true });
    }
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-jk-about]'), function (root) {
      intro(root);
      parallax(root);
      if (root.hasAttribute('data-jk-trail')) trail(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
